import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import { AuthProvider, useAuth } from './context/AuthContext';
import theme from './theme';

import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import StockList from './pages/StockList';
import Disposables from './pages/Disposables';
import Implants from './pages/Implants';
import AddItem from './pages/AddItem';
import Vendors from './pages/Vendors';
import Navigation from './components/Navigation';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Navigate to="/stock" /> : children;
};

const AppContent = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />
        <Route path="/signup" element={
          <PublicRoute>
            <Signup />
          </PublicRoute>
        } />
        <Route path="/forgot-password" element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } />
        <Route path="/stock" element={
          <ProtectedRoute>
            <Navigation />
            <StockList />
          </ProtectedRoute>
        } />
        <Route path="/disposables" element={
          <ProtectedRoute>
            <Navigation />
            <Disposables />
          </ProtectedRoute>
        } />
        <Route path="/implants" element={
          <ProtectedRoute>
            <Navigation />
            <Implants />
          </ProtectedRoute>
        } />
        <Route path="/add-item" element={
          <ProtectedRoute>
            <Navigation />
            <AddItem />
          </ProtectedRoute>
        } />
        <Route path="/vendors" element={
          <ProtectedRoute>
            <Navigation />
            <Vendors />
          </ProtectedRoute>
        } />
        <Route path="/" element={<Navigate to="/stock" />} />
      </Routes>
    </Router>
  );
};

const App = () => {
  return (
    <CssVarsProvider theme={theme} defaultMode="light">
      <CssBaseline />
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </CssVarsProvider>
  );
};

export default App;

